


























import { Component, Vue, Prop } from "vue-property-decorator";

@Component({ components: {} })
export default class PlantSearch extends Vue {
  @Prop() readonly text!: string;

  mounted() {
    this.searchText = this.text || "";
  }

  searchText: string = "";

  search() {
    if (this.searchText) {
      this.$router.push({ path: `/search/${this.searchText.toLowerCase()}` });
    }
  }
}
